import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = [
        "checkbox",
        "values",
        "button"
    ]

    connect() {
        this.syncCheckAll()
    }

    // Rows arrive and leave under this controller — infinite scroll appends a page,
    // a search swaps the whole list — and the header has to be told, or it keeps
    // saying "all of them" about a list it has never seen all of.
    checkboxTargetConnected() {
        this.syncCheckAll()
    }

    checkboxTargetDisconnected() {
        this.syncCheckAll()
    }

    // Ticked, dashed or empty, from what the rows actually say. `indeterminate` is a
    // property and not an attribute — there is no way to write this state in HTML.
    syncCheckAll() {
        if (!this.hasValuesTarget || this.valuesTarget.type !== "checkbox") return

        const total = this.checkboxTargets.length
        const checked = this.checkedValues().length

        this.valuesTarget.checked = total > 0 && checked === total
        this.valuesTarget.indeterminate = checked > 0 && checked < total
    }

    checkedValues() {
        let checkedValues = []

        this.checkboxTargets.forEach((element, id) => {
            // console.log("Checkbox value:", element.value)
            // console.log("Checkbox checked: ", element.checked)
            if (element.checked) {
                checkedValues.push(element.value)
            }
        })

        return checkedValues
    }

    setValues() {
        this.valuesTarget.value = this.checkedValues().toString()
    }

    setButtonState() {
        this.buttonTarget.disabled = (this.checkedValues().length === 0)
    }

    check(event) {
        this.setValues()
        this.setButtonState()
        this.syncCheckAll()
    }

    checkAll(event) {

        this.checkboxTargets.forEach((element) => {
           element.checked = true
        })
        this.setValues()
        this.setButtonState()
        this.syncCheckAll()
    }

    uncheckAll(event) {
        this.checkboxTargets.forEach((element, id) => {
            element.checked = false
        })

        this.setValues()
        this.setButtonState()
        this.syncCheckAll()
    }
    toggleCheckAll(event) {
        if (event.target.checked) {
            this.checkAll(event)
        } else {
            this.uncheckAll(event)
        }
    }

}
